module.exports = __webpack_public_path__ + "media/images/515151sw-81a43dcb6b9c969e7ae34bdb2add7ecc.png";